export const techData = [
  {
    tech_name: 'Angular',
    url: 'login',
    images: 'assets/images/landing/tech-angular.svg',
    target: true,
    tooltip: 'Angular',
    description:
      'Able Pro Angular dashboard template is a powerful tool that utilizes the Google Material component library to create stunning and intuitive user interfaces',
    freeRepo: true
  },
  {
    tech_name: 'React MUI',
    url: 'https://ableproadmin.com/react/dashboard/default',
    images: 'assets/images/landing/tech-react.svg',
    target: true,
    tooltip: 'React MUI',
    description:
      'Able Pro React dashboard template is a powerful tool that utilizes the Material-UI component library to create stunning and intuitive user interfaces.',
    freeRepo: true
  },
  {
    tech_name: 'Bootstrap 5',
    url: 'https://ableproadmin.com/dashboard/index.html',
    images: 'assets/images/landing/tech-bootstrap.svg',
    target: true,
    tooltip: 'Bootstrap 5',
    description:
      ' Able Pro Bootstrap 5 - the top choice for responsive, mobile-first design, you can achieve both professional functionality and visual appeal.',
    freeRepo: true
  },
  {
    tech_name: 'CodeIgniter',
    url: 'https://ableproadmin.com/codeigniter/default/public/dashboard-default',
    images: 'assets/images/landing/tech-codeigniter.svg',
    target: true,
    tooltip: 'CodeIgniter',
    description:
      'Able Pro CodeIgniter version is a powerful dashboard template built specifically for developers who use the CodeIgniter PHP framework with Bootstrap.',
    freeRepo: false
  },
  {
    tech_name: 'ASP.net',
    url: 'https://able-pro.azurewebsites.net/Dashboard/Index',
    images: 'assets/images/landing/tech-net.svg',
    target: true,
    tooltip: 'ASP.net',
    description:
      'Able Pro .NET version is a robust dashboard template designed specifically for .NET developers. Its comes with a wide range of pre-built components.',
    freeRepo: false
  },
  {
    tech_name: 'Next js',
    url: 'https://able-pro-material-next-ts-navy.vercel.app/dashboard/default',
    images: 'assets/images/landing/tech-nextjs.svg',
    target: true,
    tooltip: 'Next js',
    description:
      'Able Pro Next Js dashboard template is a powerful tool that utilizes the Material-UI component library to create stunning and intuitive user interfaces.',
    freeRepo: false
  },
  {
    tech_name: 'Vue',
    url: 'https://ableproadmin.com/vue/dashboard/default',
    images: 'assets/images/landing/tech-vuetify.svg',
    target: true,
    tooltip: 'Vue',
    description:
      'Able Pro Vue stands out as a versatile and powerful - Vue with Vuetify dashboard combines modern design principles with robust functionality.',
    freeRepo: true
  },
  {
    tech_name: 'Tailwind',
    url: 'https://ableproadmin.com/tailwind/dashboard/index.html',
    images: 'assets/images/landing/tech-tailwind.svg',
    target: true,
    tooltip: 'Tailwind',
    description:
      "Able Pro with Tailwind CSS lets developers create sleek, professional interfaces quickly. Tailwind's utility classes ensure consistent styling across all devices.",
    freeRepo: false
  },
  {
    tech_name: 'Vue+Laravel',
    url: 'https://phplaravel-207002-4524103.cloudwaysapps.com/build/dashboards/default',
    images: 'assets/images/landing/tech-l+v.svg',
    target: true,
    tooltip: 'Vue+Laravel',
    description:
      'Able Pro Vue + Laravel stands out as a versatile and powerful admin dashboard solution, seamlessly combining the modern design principles of Vue.js with the robust backend capabilities of Laravel.',
    freeRepo: false
  },
  {
    tech_name: 'Django',
    url: 'javascript:',
    images: 'assets/images/landing/tech-django.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Able Pro Django is a powerful dashboard template designed for developers. it offers an extensive collection of pre-built components for seamless web development.',
    freeRepo: false
  },
  {
    tech_name: 'Flask',
    url: 'javascript:',
    images: 'assets/images/landing/tech-flask.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Able Pro Flask is a versatile dashboard solution that offers a rich set of pre-built components to simplify web development.',
    freeRepo: false
  },
  {
    tech_name: 'Laravel Bootstrap',
    url: 'javascript:',
    images: 'assets/images/landing/tech-laravel+bootstrap.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Able Pro Laravel with Bootstrap provides a powerful set of tools and components, crafted specifically for Laravel, to simplify and accelerate your development process.',
    freeRepo: false
  },
  {
    tech_name: 'Node Js',
    url: 'javascript:',
    images: 'assets/images/landing/tech-nodejs.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Able Pro Node.js combines flexibility and functionality with a variety of pre-built components tailored for Node.js, which make it easier to develop.',
    freeRepo: false
  },
  {
    tech_name: 'Svelte Kit',
    url: 'javascript:',
    images: 'assets/images/landing/tech-svelteKit.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Able Pro Svelte provides an extensive toolkit and components, allowing you to build dynamic and responsive interfaces with ease and efficiency.',
    freeRepo: false
  }
  // {
  //   tech_name: 'Figma',
  //   url: 'https://www.figma.com/file/6XqmRhRmkr33w0EFD49acY/Able-Pro--v9.0-Figma-Preview?type=design&mode=design&t=0XZ5hhGAwBPr4Qlj-0',
  //   images: 'assets/images/landing/tech-figma.svg',
  //   target: true,
  //   tooltip: 'Figma',
  //   description:
  //     'Able Pro comes with a Figma design file that allows you to customize and fine-tune your dashboard to meet your specific needs.',
  //   freeRepo: false
  // }
];
